export default __webpack_public_path__ + "static/media/two-factor-authentication-illustration-dark.b1796a7d.svg";